var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('embed',{attrs:{"src":"https://meeting.iotech.my.id/?app=ACCOUNTING#/projectdocumentintegration","width":"100%","height":"800"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }